import React, { useState, useEffect, useRef } from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@material-ui/core";
import useTable from "../useTable";
import { Dimmer } from "../spinner";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { GestionAsignacionMulta } from "./modalAsignarMulta";
import axios from "axios";

const TablaAsignacionMulta = (props) => {
  var op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));

  const headCells = [
    {
      id: "codigo",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code">
          {" "}
          CÓDIGO
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "Descripción",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-signature">
          {" "}
          NOMBRE
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "Código Clase",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code-branch">
          {" "}
          RIF
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-cogs">
          {" "}
          OPCIONES
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
  ];

  const [mostrar2, setMostrar2] = useState(false);
  const [agente, setAgente] = useState();
  const [mostrar4, setMostrar4] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [claseMulta, setClaseMulta] = useState([]);
  const [tipoimpuesto, setTipoImpuestoCat] = useState();
  const [operacion, setOperacion] = useState(1);
  const [impuestos, setImpuestos] = useState();
  const [idTipoImpuesto, setIdTipoImpuesto] = useState();
  const txtBuscador = useRef();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.idagente.includes(target.value) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
              x.rif.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  const SeleccionarImpuestos = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "tipoimpuesto";
    let condi = "idtipoimpuesto <= 4 ";
    let orden = "idtipoimpuesto";

    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?&campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setImpuestos(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const SeleccionarRegistros = (condi) => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/multas/agentemulta?condi=${condi}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionaregistro = (id) => (e) => {
    e.preventDefault();

    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    console.log(endpoint);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            setAgente(response.data);
            setMostrar2(true);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const onChangeRegistros = (e) => {
    //e.preventDefault()
    // console.log(e.target.value)
    // setTipoImpuestoCat(tabla)
    //setIdTipoImpuesto(id)
    let condi = "";
    let sigue = false;
    let valor = e.target.value;
    //  console.log(tabla,id)
    if (valor === "1") {
      setTipoImpuestoCat(valor);
      setIdTipoImpuesto("1");
      condi = "mina = true";
      sigue = true;
    } else if (valor === "2") {
      setTipoImpuestoCat(valor);
      setIdTipoImpuesto("2");
      condi = "produccion = true";
      sigue = true;
    } else if (valor === "3") {
      setTipoImpuestoCat(valor);
      setIdTipoImpuesto("3");
      condi = "impuesto1x500 = true";
      sigue = true;
    } else if (valor === "4") {
      setTipoImpuestoCat(valor);
      setIdTipoImpuesto("4");
      condi = "expendedor = true";
      sigue = true;
    } else {
      setRecords([]);
    }

    if (sigue) {
      SeleccionarRegistros(condi);
    }
  };

  const handleCancela2 = () => {
    setMostrar2(false);
  };

  const handleCloseSi = () => {
    setActivate(false);
    /* SeleccionarRegistro(); */
    setMostrar4(false);
  };

  useEffect(() => {
    /*  SeleccionarRegistros(); */
    SeleccionarImpuestos();
    setActivate(true);
  }, []);

  return (
    <div
      className="px-5"
      style={{ backgroundColor: "#", height: "100%", width: "100%" }}
    >
      <div className="row  col-md-12 py-5 px-5">
        <div className="px-5 row">
          <div className="col-md-12 p-2 mt-4">
            <div className="row col-md-12 d-flex justify-content-between">
              <div className="input-group input-group-sm col-sm-4 mb-2 ">
                <label className="fw-bold mr-1" id="inputGroup-sizing-sm">
                  Tipo de Impuesto:
                </label>
                <select
                  className="form-select form-select-sm rounded-pill"
                  id="inputStatus"
                  name="tipoimpuesto"
                  onChange={onChangeRegistros}
                >
                  <option value="">Seleccione</option>
                  {impuestos &&
                    impuestos.map((item, index) => (
                      <option
                        key={index}
                        value={
                          item.idtipoimpuesto
                        } /*value={item.tabla} onClick={onChangeRegistros(item.tabla,item.idtipoimpuesto)} */
                      >
                        {" "}
                        {item.descripcion.trim()}{" "}
                      </option>
                    ))}
                </select>
              </div>
              <input
                type="text"
                className=" col-3 form-control form-control-sm rounded-pill"
                ref={txtBuscador}
                onChange={handleSearch}
                placeholder="Buscar"
              />
            </div>
          </div>
          <div className="col-md-12" style={{ margin: "auto" }}>
            <TblContainer>
              <TblHead />

              <TableBody>
                {records &&
                  recordsAfterPagingAndSorting().map((item, index) => (
                    <TableRow key={index} style={{ padding: "0" }}>
                      <TableCell style={{ textAlign: "center" }}>
                        {item.idagente}
                      </TableCell>
                      <TableCell style={{ textAlign: "left" }}>
                        {item.nombre}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {item.rif}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        <button
                          onClick={seleccionaregistro(item.idagente)}
                          className="btn btn-sm  btn-info rounded-pill ml-2"
                        >
                          <i className="fas fa-edit">Asignar</i>{" "}
                        </button>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </TblContainer>
            <TblPagination />
          </div>
        </div>

        <GestionAsignacionMulta
          show={mostrar2}
          onHideCancela={handleCancela2}
          claseMulta={claseMulta}
          operacion={operacion}
          tipoimpuesto={tipoimpuesto}
          agente={agente}
          idTipoImpuesto={idTipoImpuesto}
        />

        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
      </div>
      <Dimmer active={activate} />
    </div>
  );
};
export default TablaAsignacionMulta;



// WEBPACK FOOTER //
// ./src/components/multas/tablaAsignacionMulta.js